import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { provideOktaAuth, withOktaConfig } from '@okta/okta-angular';

import { OktaRoutingModule } from './okta-routing.module';
import { oktaConfig } from './configuration/okta';

@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    OktaRoutingModule,
  ],
  exports: [
  ],
  providers: [
    provideOktaAuth(withOktaConfig(oktaConfig))
  ]
})
export class OktaModule { }
